import { render, staticRenderFns } from "./MaterialFolderEditDialog.vue?vue&type=template&id=342156a2&scoped=true"
import script from "./MaterialFolderEditDialog.vue?vue&type=script&lang=ts"
export * from "./MaterialFolderEditDialog.vue?vue&type=script&lang=ts"
import style0 from "./MaterialFolderEditDialog.vue?vue&type=style&index=0&id=342156a2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342156a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('342156a2')) {
      api.createRecord('342156a2', component.options)
    } else {
      api.reload('342156a2', component.options)
    }
    module.hot.accept("./MaterialFolderEditDialog.vue?vue&type=template&id=342156a2&scoped=true", function () {
      api.rerender('342156a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/MaterialFolderEditDialog.vue"
export default component.exports